// Documentation:
// https://devexpress.github.io/devextreme-reactive/react/scheduler/docs/guides/appointment-tooltip/
import React, { useState } from "react";
import { ViewState, EditingState } from "@devexpress/dx-react-scheduler";
import {
  Scheduler,
  DayView,
  WeekView,
  MonthView,
  Appointments,
  AllDayPanel,
  AppointmentForm,
} from "@devexpress/dx-react-scheduler-material-ui";
import AppointmentModal from "components/modals/appointmentModal";
import RescheduleModal from "components/modals/reschedule";
import FollowUpModal from "components/modals/followUp";
import ChatModal from "components/modals/chatModal";
import CalendarHeader from "components/CalendarHeader";
import Loading from "components/modals/Loading";
import AddAppointment from "components/modals/AddAppointment";
import { useUserData } from "components/customHooks/userDataContext";
import { startOfWeek, addDays } from "date-fns";
import { getAppointments } from "apiHandler/actions";
import {
  displayDateFormatter,
  isoDateFormatter,
  addMinutes,
} from "components/helpers";
import { Paper } from "@mui/material";

const getStatusColor = (status) => {
  switch (status?.toLocaleUpperCase()) {
    case "PENDING ARRIVAL":
      return "#1dbc60";
    case "SEEN":
      return "#CD9933";
    case "NO SHOW":
      return "#CD3367";
    case "CANCELLED":
      return "#33CCCB";
    case "IN LOBBY":
      return "#d6e9e5";
    case "IN ROOM":
      return "#b1cdcc";
    case "Pending":
      return "#f3d183";
    case "CONFIRMED":
      return "#f2d0ad";
    default:
      return "#f1ce83";
  }
};
const Calendar = () => {
  const [currentViewName, setCurrentViewName] = useState("Day");
  // const [filter, setFilter] = useState("viewall");
  const [showRescheduleModal, setShowRescheduleModal] = useState(false);
  const [showFollowUpModal, setShowFollowUpModal] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [showChatModal, setShowChatModal] = useState(false);
  const [selAppt, setSelAppt] = useState(null);
  const [loading, setLoading] = useState(false);
  const [date, setDate] = useState(new Date());
  const [appointments, setAppointments] = useState([]);
  const [selectedDateForAppnt, setSelectedDateForAppnt] = useState(null);
  const userData = useUserData();
  const token = userData?.access_token;

  const fetchData = async () => {
    setLoading(true);
    const payload = {
      search_criteria: {
        practice_id: `${userData.selected_practice}`,
        user_id: userData?.email,
      },
    };
    let startDateTime;
    let endDateTime;
    if (currentViewName === "Month") {
      startDateTime = `${date.getMonth() + 1}/01/${date.getFullYear()}`;
      endDateTime = `${date.getMonth() + 2}/01/${date.getFullYear()}`;
    } else if (currentViewName === "Week") {
      startDateTime = startOfWeek(date);
      endDateTime = addDays(startDateTime, 7);
      startDateTime = displayDateFormatter(startDateTime);
      endDateTime = displayDateFormatter(endDateTime);
    }
    if (startDateTime && endDateTime) {
      payload["search_criteria"]["start_dos"] = startDateTime;
      payload["search_criteria"]["end_dos"] = endDateTime;
    } else {
      payload["search_criteria"]["dos"] = displayDateFormatter(date);
    }
    const response = await getAppointments(payload, token);
    if (response)
      setAppointments(
        response.map((a) => ({
          ...a,
          patient_name: a.first_name + " " + a.last_name,
          title: a.first_name + " " + a.last_name,
          // startDate: `${isoDateFormatter(a.dos)}T${a.dos_time.split(" ")[0]}`,

          startDate: `${isoDateFormatter(a.dos)}T${a.dos_time && addMinutes(a.dos_time)}`,
          endDate: `${isoDateFormatter(a.dos)}T${
            a.dos_time && addMinutes(a.dos_time, a.duration, true)
          }`,
          // endDate: '2018-11-01T11:00',
          appntId: a.id,
        })),
      );
    else setAppointments([]);
    setLoading(false);
  };

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const CustomAppointment = ({ children, style, ...restProps }) => {
    const data = { ...restProps }["data"];
    let statusColor = getStatusColor(data.status);
    const bgColor = statusColor;
    return (
      <Appointments.Appointment
        {...restProps}
        style={{
          ...style,
          backgroundColor: bgColor,
          borderRadius: "8px",
          padding: 5,
        }}
        onClick={() => {
          setSelAppt(data);
          // if (appntStatus === "noshow") setShowRescheduleModal(true);
          // else if (appntStatus === "completed") setShowFollowUpModal(true);
          // else
          setShowModal(true);
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            color: "#000000",
            fontSize: 12,
            fontWeight: "400",
          }}
        >
          <div>
            {data.title}
            <br />
            {`(${data.status})`}
          </div>
        </div>
      </Appointments.Appointment>
    );
  };
  return (
    <div className="provider-calendar-container">
      <CalendarHeader
        currentViewName={currentViewName}
        setCurrentViewName={setCurrentViewName}
        setAppointments={setAppointments}
        setLoading={setLoading}
        date={date}
        setDate={setDate}
      />
      {loading && <Loading />}
      <Paper>
        <Scheduler
          data={appointments}
          height={currentViewName === "Month" ? 695 : 1035}
          onClick={(e) => console.log("schedure edit", e)}
        >
          <ViewState currentDate={date} currentViewName={currentViewName} />
          <DayView startDayHour={8} endDayHour={17} />
          <WeekView startDayHour={8} endDayHour={17} />
          <MonthView />
          <Appointments appointmentComponent={CustomAppointment} />
          <AllDayPanel />
          <EditingState
            onAddedAppointmentChange={(e) => {
              setSelectedDateForAppnt(e.startDate);
            }}
          />
          <AppointmentForm visible={false} />
        </Scheduler>
      </Paper>
      {showModal && selAppt && (
        <AppointmentModal
          {...selAppt}
          appointment={selAppt}
          onClose={() => {
            setShowModal(false);
            setSelAppt(false);
          }}
          showRescheduleModal={() => {
            setShowModal(false);
            setShowRescheduleModal(true);
          }}
          showChatModal={() => {
            setShowModal(false);
            setShowChatModal(true);
          }}
        />
      )}
      {showRescheduleModal && (
        <RescheduleModal
          {...selAppt}
          onClose={() => {
            setShowRescheduleModal(false);
            setSelAppt(false);
          }}
        />
      )}
      {showFollowUpModal && (
        <FollowUpModal
          {...selAppt}
          onClose={() => {
            setShowFollowUpModal(false);
            setSelAppt(false);
          }}
        />
      )}
      {showChatModal && (
        <ChatModal
          {...selAppt}
          onClose={() => {
            setShowChatModal(false);
            setSelAppt(false);
          }}
        />
      )}
      {selectedDateForAppnt ? (
        <AddAppointment
          default_date={selectedDateForAppnt}
          onClose={(isAdded) => {
            if (isAdded) fetchData();
            setSelectedDateForAppnt(null);
          }}
        />
      ) : null}
    </div>
  );
};

export default Calendar;
